var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 0,
    height: 0,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "dots",
    clipPathUnits: "objectBoundingBox",
    transform: "scale(0.015625 0.03125)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 0.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 1.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 2.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 3.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 4.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 5.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 6.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 7.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 8.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 9.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 10.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 11.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 12.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 13.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 14.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 15.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 16.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 17.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 18.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 19.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 20.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 21.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 22.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 23.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 24.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 25.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 26.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 27.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 28.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 29.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 30.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 31.5,
    r: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 31.5,
    r: 0.3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.d53337051bde9d2a2878d855913948ed.svg";
export { ForwardRef as ReactComponent };